export { default as LoyaltyOffersCooldown } from './loyalty-offers-cooldown';
